__turbopack_context__.v({
  "button": "carousel-module__1NLMFa__button",
  "buttonNext": "carousel-module__1NLMFa__buttonNext",
  "buttonPrev": "carousel-module__1NLMFa__buttonPrev",
  "container": "carousel-module__1NLMFa__container",
  "containerVertical": "carousel-module__1NLMFa__containerVertical",
  "item": "carousel-module__1NLMFa__item",
  "itemVertical": "carousel-module__1NLMFa__itemVertical",
  "root": "carousel-module__1NLMFa__root",
  "viewport": "carousel-module__1NLMFa__viewport",
});
